import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import MyRicePoints from "@/pages/MyRicePoints";
import MyOrders from "@/pages/MyOrders";
import Account from "@/pages/Account";
import TradeRice from "@/pages/TradeRice";
import TradeInStatus from "@/pages/TradeInStatus";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTradeIns from "@/pages/admin/AdminTradeIns";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSimulator from "@/pages/admin/AdminSimulator";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminWhatsApp from "@/pages/admin/AdminWhatsApp";
import StaffDashboard from "@/pages/staff/StaffDashboard";

const ADMIN = ["admin", "super_admin"];

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:category" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/trade" element={<TradeRice />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/cart" element={<Cart />} />

        <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
        <Route path="/ricepoints" element={<ProtectedRoute><MyRicePoints /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        <Route path="/trade/:id" element={<ProtectedRoute><TradeInStatus /></ProtectedRoute>} />

        <Route path="/staff" element={<ProtectedRoute roles={["staff", "admin", "super_admin"]}><StaffDashboard /></ProtectedRoute>} />

        <Route path="/admin" element={<ProtectedRoute roles={ADMIN}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/tradeins" element={<ProtectedRoute roles={ADMIN}><AdminTradeIns /></ProtectedRoute>} />
        <Route path="/admin/products" element={<ProtectedRoute roles={ADMIN}><AdminProducts /></ProtectedRoute>} />
        <Route path="/admin/orders" element={<ProtectedRoute roles={ADMIN}><AdminOrders /></ProtectedRoute>} />
        <Route path="/admin/customers" element={<ProtectedRoute roles={ADMIN}><AdminCustomers /></ProtectedRoute>} />
        <Route path="/admin/simulator" element={<ProtectedRoute roles={ADMIN}><AdminSimulator /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute roles={ADMIN}><AdminSettings /></ProtectedRoute>} />
        <Route path="/admin/whatsapp" element={<ProtectedRoute roles={ADMIN}><AdminWhatsApp /></ProtectedRoute>} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
